@if (toasts && toasts.length) {
  <div class="sh-toast-container">
    @for (toast of toasts; track trackToastById($index, toast)) {
      <sh-toast [toast]="toast" (toastClosed)="closeToastById(toast.id)"></sh-toast>
    }
  </div>
}
